export default {
  main: '#0073B0',
  secondary: '#8FCAE7',
  contrastingColor: '#ffffff',
  priceColor: '#8FCAE7',
  entryBackground: '#ffffff',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
